import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 22,
	viewBox: "0 0 18 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.88 1.625C7.84446 1.625 7.005 2.46447 7.005 3.5V13.9733L4.46 11.4292C3.72707 10.6969 2.53932 10.6975 1.80708 11.4304C1.07484 12.1633 1.0754 13.3511 1.80833 14.0833L7.55833 19.8283C7.90996 20.18 8.38688 20.3775 8.88416 20.3775C9.38145 20.3775 9.85837 20.18 10.21 19.8283L15.9508 14.0833C16.6831 13.3511 16.6831 12.1639 15.9508 11.4317C15.2186 10.6994 14.0314 10.6994 13.2992 11.4317L10.755 13.9758V3.5C10.755 3.00272 10.5575 2.52581 10.2058 2.17417C9.85419 1.82254 9.37728 1.625 8.88 1.625Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2222%22%20viewBox%3D%220%200%2018%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.88%201.625C7.84446%201.625%207.005%202.46447%207.005%203.5V13.9733L4.46%2011.4292C3.72707%2010.6969%202.53932%2010.6975%201.80708%2011.4304C1.07484%2012.1633%201.0754%2013.3511%201.80833%2014.0833L7.55833%2019.8283C7.90996%2020.18%208.38688%2020.3775%208.88416%2020.3775C9.38145%2020.3775%209.85837%2020.18%2010.21%2019.8283L15.9508%2014.0833C16.6831%2013.3511%2016.6831%2012.1639%2015.9508%2011.4317C15.2186%2010.6994%2014.0314%2010.6994%2013.2992%2011.4317L10.755%2013.9758V3.5C10.755%203.00272%2010.5575%202.52581%2010.2058%202.17417C9.85419%201.82254%209.37728%201.625%208.88%201.625Z%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E%0A";
